<template>
    <div class="condition-status-page">
        <ConditionStatusStaticHeaderContent
            :generator-id="generatorId"
            :is-content-displayed="isContentDisplayed"
        />
        <div class="condition-status-page__content">
            <ConditionStatusContent
                v-if="isContentDisplayed && generatorId"
                :key="generatorId"
                :generator-id="generatorId"
            />
            <pbl-panel v-else>
                <div class="condition-status-page__content__empty-state">
                    <pbl-icon name="check2-square" />
                    <span>
                        {{ t('generators.conditionStatus.emptyStateBody') }}
                    </span>
                </div>
            </pbl-panel>
        </div>
    </div>
</template>

<script setup lang="ts">
import ConditionStatusContent from '@/pages/generators/condition-status/ConditionStatusContent.vue'
import {
    flattenGeneratorsHierarchy,
    useGeneratorsHierarchyQuery,
} from '@/api/queries/generators/useGeneratorsHierarchyQuery'
import { computed } from 'vue'
import ConditionStatusStaticHeaderContent from '@/pages/generators/condition-status/ConditionStatusStaticHeaderContent.vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    generatorId?: string
}>()

const { t } = useI18n()

const { data } = useGeneratorsHierarchyQuery()

const generatorList = computed(() => {
    if (!data.value?.plantGroups) {
        return []
    }

    return flattenGeneratorsHierarchy(data.value.plantGroups)
})

const isContentDisplayed = computed(
    () =>
        !!(
            data.value &&
            props.generatorId &&
            generatorList.value.find((e) => e.generator.id === props.generatorId)
        ),
)
</script>

<style scoped lang="scss">
.condition-status-page {
    display: flex;
    flex-direction: column;

    max-height: calc(100vh - $navbar-height * 2);

    &__content {
        @include spacing-page;
        overflow-y: scroll;

        &__empty-state {
            padding: 50px 0;

            display: flex;
            flex-direction: column;

            align-items: center;
            justify-content: center;
            gap: $spacing-s;

            color: $pbl-text-muted;

            pbl-icon {
                --size: 2rem;
            }

            span {
                font-weight: 500;
                font-size: 1.25rem;
            }
        }
    }
}
</style>
